var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAdd = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "#4C89FE",
  rx: 12
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#333443",
  fillRule: "evenodd",
  d: "M12 6a.975.975 0 0 0-.975.975v4.05h-4.05a.975.975 0 1 0 0 1.95h4.05v4.05a.975.975 0 1 0 1.95 0v-4.05h4.05a.975.975 0 1 0 0-1.95h-4.05v-4.05A.975.975 0 0 0 12 6",
  clipRule: "evenodd"
})));
export { SvgAdd as ReactComponent };